import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import _ from 'lodash';
import { RootState } from 'store';

import { searchCountriesAutocomplete } from 'actions/countriesAutocomplete';
import { CountryAutoComplete } from 'models/countryAutoComplete';
import CountriesAutoCompleteSearch from 'components/CountriesAutoCompleteSearch';

interface Props {
  show: boolean;
  placeHolder: string;
  onClose: () => void;
  onChange: (country?: CountryAutoComplete) => void;
}

const AutoCompleteCountriesSearchContainer = (props: Props) => {
  const dispatch = useDispatch();
  const countriesState = useSelector((state: RootState) => state.countriesAutoComplete);

  const handleSearchChange = _.debounce((value: string) => {

    if (value && value.length > 2) {
      dispatch(searchCountriesAutocomplete(value));
    }
  }, 250);

  return <CountriesAutoCompleteSearch {...props} {...countriesState} minLengthForSearch={2} onSearchChange={handleSearchChange} />;
};

export default AutoCompleteCountriesSearchContainer;
